import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';

import HtmlText from 'html-text/HtmlText';
import Explainer from './Explainer';
import PriceProduct from './PriceProduct';
import PriceCommodity from './PriceCommodity';

import { isEmeaCountry } from '../constants/countryCodes';

const baseString = 'vra-planting-plan__prices';
const Prices = ({
  accountCountry,
  bagSize,
  currency,
  isReviewScriptStep,
  onChangePriceCommodity,
  onChangePriceProduct,
  plantingPlanParams,
  validationResult
}) => {
  const priceCommodityValidationResult = get(validationResult, 'resultsByKey.priceCommodity');
  const priceProductValidationResult = get(validationResult, 'resultsByKey.priceProduct');


  const classString = classNames({
    [`${baseString}`]: true,
    'vra-planting-plan-form__fieldset': true,
    'vra-planting-plan-form__on-review-step': isReviewScriptStep
  });

  return (
    <div>
      <section className={classString}>
        <div className='vra-planting-plan-form__inputs-wrapper'>
          <PriceProduct
            accountCountry={accountCountry}
            bagSize={bagSize}
            currency={currency}
            isReviewScriptStep={isReviewScriptStep}
            onChangePriceProduct={onChangePriceProduct}
            plantingPlanParams={plantingPlanParams}
            priceProductValidationResult={priceProductValidationResult}
          />
          {isReviewScriptStep && <div className={`${baseString}__spacing`}/>}
          <PriceCommodity
            currency={currency}
            onChangePriceCommodity={onChangePriceCommodity}
            plantingPlanParams={plantingPlanParams}
            priceCommodityValidationResult={priceCommodityValidationResult}
          />
        </div>
        <Explainer isVisible={!isReviewScriptStep}>
          <HtmlText messageKey='text__advanced-script__prices' />
        </Explainer>
      </section>
      {!isReviewScriptStep && isEmeaCountry(accountCountry) && (
        <div className="vra-planting-plan-form__seed-bag-text">
          <HtmlText messageKey='text__advanced-script__seed-bag-info' messageParams={{bagSize}} />
        </div> )}
    </div>
  );
};
Prices.propTypes = {
  accountCountry: PropTypes.string.isRequired,
  bagSize: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  isReviewScriptStep: PropTypes.bool.isRequired,
  onChangePriceCommodity: PropTypes.func.isRequired,
  onChangePriceProduct: PropTypes.func.isRequired,
  plantingPlanParams: PropTypes.object.isRequired,
  validationResult: PropTypes.object
};
export default Prices;
